export default {"src":"/_next/static/media/SplineC_Pg4Dark_1440x520.6ec7b97e.svg","height":520,"width":1440,"blurWidth":0,"blurHeight":0};